<div class="m-subheader" style="position: relative;">
  <div [ngClass]="{'invisible': isLoading.invoice }" class="d-flex align-items-center"
       style="flex-wrap: wrap;">
    <div class="mr-auto">
      <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
        <li class="m-nav__item m-nav__item--home">
          <a routerLink="/" class="m-nav__link m-nav__link--icon">
            <i class="m-nav__link-icon la la-home"></i>
          </a>
        </li>
        <li class="m-nav__separator">
          -
        </li>
        <li class="m-nav__item">
          <a routerLink="../" class="m-nav__link">
            <span class="m-nav__link-text">
              {{ 'storage-invoice-edit.allInvoice' | transloco }}
            </span>
          </a>
        </li>
        <li class="m-nav__item">
        </li>
      </ul>
    </div>
  </div>

  <div *ngIf="isLoading.invoice" class="m-page-loader m-page-loader--non-block m-page-loader--absolute">
    <div class="m-loader m-loader--brand"></div>
  </div>
</div>

<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--head-solid-bg">
        <div class="m-portlet__head" style="position: relative;">
          <div [ngClass]="{'invisible': isLoading.invoice }" class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">
                {{ 'storage-invoice-edit.createInvoice' | transloco }}
              </h3>
            </div>
          </div>

          <div *ngIf="isLoading.invoice"
               class="m-page-loader m-page-loader--non-block m-page-loader--absolute">
            <div class="m-loader m-loader--brand"></div>
          </div>
        </div>

        <div class="m-portlet__body">
          <div *ngIf="!isLoading.invoice" class="row">
            <div class="col-md-12">
              <form class="m-form m-form--state" [formGroup]="invoiceForm" (ngSubmit)="onSubmitForm()">
                <div class="m-form__section">
                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12 is--required">
                      {{ 'storage-invoice-edit.shop' | transloco }}:
                    </label>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <hx-store-select [formControlName]="invoiceFormKeys.storeId" (selectChange)="loadProperty($event)"></hx-store-select>
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12">
                      {{ 'storage-invoice-edit.number' | transloco }}:
                    </label>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <input type="text" [formControlName]="invoiceFormKeys.incomingInvoiceNumber"
                             class="form-control m-input" placeholder="">
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12 is--required">
                      {{ 'storage-invoice-edit.data' | transloco }}:
                    </label>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <hx-date-select [formControlName]="invoiceFormKeys.incomingInvoiceDate"></hx-date-select>
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12 is--required">
                      {{ 'storage-invoice-edit.supplier' | transloco }}:
                    </label>

                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <app-suppliers-search [storeId]="invoiceForm.controls.storeId.value" [formControlName]="invoiceFormKeys.supplierId"></app-suppliers-search>
                    </div>
                  </div>

                  <div class="form-group m-form__group row"
                       *ngIf="invoiceForm.controls.supplierId.value">
                    <label class="col-form-label col-lg-3 col-sm-12 is--required" [ngClass]="{'is--required': invContractProperty && invContractProperty.required }">
                      {{ 'storage-invoice-edit.treaty' | transloco }}:
                    </label>

                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <app-contract-search [loadImmediately]="true" [supplierId]="invoiceForm.controls.supplierId.value"
                                           formControlName="contractId" [organizationId]="organziationId"
                                           (itemSelect)="onContractChanged($event)"></app-contract-search>

                      <div class="m-widget4 m-widget4--padding" *ngIf="selectedContract?.files?.length > 0">
                        <div class="m-widget4__item" *ngFor="let file of selectedContract?.files">
                          <a *ngIf="file.mimeType !== 'application/pdf'" class="m-widget4__img m-widget4__img--icon"
                             (click)="showImage(file)">
                            <img [src]="baseLink + file?.guid" [alt]="file?.fileName">
                          </a>
                          <a *ngIf="file.mimeType === 'application/pdf'" class="m-widget4__img m-widget4__img--icon"
                             (click)="showImage(file)">
                            <i class="la la-file-pdf-o la-2x"></i>
                          </a>
                          <div class="m-widget4__info" [title]="file.fileName">
                            <span class="m-widget4__text">
                              {{ file.fileName }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="currency" class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12">
                      {{ 'storage-invoice-edit.currency' | transloco }}:
                    </label>

                    <div class="col-lg-6 col-md-6 col-sm-12">
                      {{  currencyName }}
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12 is--required">
                      {{ 'storage-invoice-edit.spendType' | transloco }}:
                    </label>

                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <app-spend-category-search [disabled]="true" [code]="invoiceForm.controls.spendCategoryCode.value"  (update)="selectSpendCategory($event)"></app-spend-category-search>
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12" [ngClass]="{'is--required': isStorageInvoiceFileRequired }">
                      {{ 'storage-invoice-edit.file' | transloco }}:
                    </label>

                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <hx-file-list [fileList]="fileList" (fileRemove)="updateDeletedList($event)"></hx-file-list>
                      <hx-file-upload (updateFiles)="updateFiles($event)" [size]="5" [folder]="folderPurchase"></hx-file-upload>
                    </div>
                  </div>

                  <div class="form-group m-form__group m-form__group--colored row">
                    <label class="col-form-label col-lg-3 col-sm-6 is--required">
                      {{ 'storage-invoice-edit.product' | transloco }}:
                    </label>

                    <div class="col-lg-3 col-md-3 col-sm-6">
                      <button *ngIf="invoiceForm.controls.storeId.value" (click)="addItem()" type="button"
                              class="btn btn-success m-btn m-btn--icon m--margin-bottom-15">
                        <span>
                          <i class="la la-plus"></i>
                          <span>
                            {{ 'storage-invoice-edit.btn.addProduct' | transloco }}
                          </span>
                        </span>
                      </button>
                      <span *ngIf="!invoiceForm.controls.storeId.value">{{ 'storage-invoice-edit.noChoose' | transloco }}</span>
                    </div>
                  </div>
                  <div
                    class="form-group m-form__group form-group m-form__group--colored m-form__group--last m-form__group--first"
                    [formArrayName]="invoiceFormKeys.products"
                    *ngFor="let item of asFormArray(invoiceFormKeys.products).controls; let ix = index;">
                    <ng-container [formGroupName]="ix">
                      <div class="row m--padding-bottom-15">
                        <div class="col-lg-2 col-md-2 col-sm-2">
                          <small class="is--required">{{ 'storage-invoice-edit.productName' | transloco }}:</small>
                          <app-store-product-select [storeId]="invoiceForm.controls.storeId.value" [formControlName]="productFormKeys.storeProductId"
                                                    [validateItemFn]="validateItemFn"
                                                    (selectChange)="onStoreProductSelected($event, ix)"
                                                    [isPurchasable]="true"></app-store-product-select>
                          <div *ngIf="storeProducts[ix]" style="font-weight: bold" class="very-small m--margin-top-5 text-center">
                            {{ 'storage-invoice-edit.balance' | transloco }} {{ storeProducts[ix].amount }} {{ storeProducts[ix].unitOfMeasure.localShortTitle | uiLabel }}
                          </div>
                        </div>
                        <div class="col-lg-2 col-md-2">
                          <small class="is--required">{{ 'storage-invoice-edit.numberProducts' | transloco }}:</small>
                          <input type="text" [readOnly]="storeProducts.length === 0" [formControlName]="productFormKeys.amount" class="form-control m-input" [placeholder]="'storage-invoice-edit.amount' | transloco" [title]="'storage-invoice-edit.amount' | transloco">
                          <div *ngIf="storeProducts.length > 0 && getPricePerUnit(ix) > 0" style="font-weight: bold" class="very-small m--margin-top-5 text-center">
                            {{ getPricePerUnit(ix) | uiCurrency:currency}}
                            {{ 'storage-invoice-edit.sum' | transloco }} {{ storeProducts[ix].unitOfMeasure.title | uiLabel }}
                          </div>
                        </div>
                        <div class="col-lg-2 col-md-2">
                          <small>{{ 'storage-invoice-edit.expirationStart' | transloco }}:</small>
                          <hx-date-select [disabled]="storeProducts.length === 0" [formControlName]="productFormKeys.issueDate"></hx-date-select>
                        </div>
                        <div class="col-lg-2 col-md-2">
                          <small>{{ 'storage-invoice-edit.expiration' | transloco }}:</small>
                          <hx-date-select [disabled]="storeProducts.length === 0" [formControlName]="productFormKeys.expiryDate"></hx-date-select>
                        </div>

                        <div class="col-lg-2 col-md-2">
                          <small class="is--required">{{ 'storage-invoice-edit.typeExpenses' | transloco }}:</small>
                          <hx-dictionary-select [disabled]="storeProducts.length === 0" [dictionaryKey]="dictSpendTypeKey" [formControlName]="productFormKeys.spendType"></hx-dictionary-select>
                        </div>

                        <div class="col-lg-1 col-md-1 col-sm-1">
                          <span class="d-inline-block" style="vertical-align: middle;">
                            <small class="is--required">{{ 'storage-invoice-edit.totalCost' | transloco }}:</small>
                            <input type="text" [readOnly]="storeProducts.length === 0" [formControlName]="productFormKeys.totalValue"
                                   class="form-control m-input" [placeholder]="'storage-invoice-edit.price' | transloco" [title]="'storage-invoice-edit.price' | transloco">
                          </span>
                        </div>

                        <div class="col-lg-1 col-md-1 col-sm-1 m--margin-top-5">
                          <button (click)="removeItem(ix)" type="button" style="margin-top: 1.5rem;margin-left: 1rem;" [ngbTooltip]="'storage-invoice-edit.deleteProduct' | transloco"
                                  class="m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill">
                            <i class="la la-trash"></i>
                          </button>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>

                <div class="m-form__actions m-form__actions--paddingless-sides">
                  <div class="row">
                    <div class="col-12 text-right">
                      <button [disabled]="isLoading.submit" type="submit" class="btn btn-success">
                        {{ 'btn.save' | transloco }}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div *ngIf="isLoading.invoice"
               class="m-page-loader m-page-loader--non-block m-page-loader--relative">
            <div class="m-loader m-loader--brand"></div>
          </div>
        </div>
      </div>

      <a routerLink="../" class="is--cursor-pointer">
        {{ 'storage-invoice-edit.back' | transloco }}
      </a>
    </div>
  </div>
</div>
<ng-template #templateRef let-modal>
  <div class="modal-header">
    <h3 class="modal-title">{{ image?.name }}</h3>
    <button class="close" type="button" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body text-center">
    <iframe *ngIf="image.mimeType === 'application/pdf'" class="iframe" width="100%" height="100%" [src]="image.path"
            frameborder="0"></iframe>
    <img *ngIf="image.mimeType !== 'application/pdf'" [src]="image.path" [alt]="image?.name"
         style="max-width: 100%;">
  </div>
</ng-template>
